import { v4 as uuidv4 } from "uuid";
import { makeAutoObservable, reaction } from "mobx";

class Note {
  constructor(id = uuidv4(), date = Date(), text = "", client = null) {
    this.id = id;
    this.date = date;
    this.text = text;
    this.client = client;
    makeAutoObservable(this);
    reaction(
      () => ({
        text: this.text,
      }),
      () => {
        if (this.client) {
          this.client.updateClientTransactionNotes(this.id);
          this.client.startOrResetBatchTimer();
        }
      }
    );
  }
  setNoteText(newText) {
    this.text = newText;
  }

  updateNote(noteData) {
    this.text = noteData.text;
  }

  uploadToCloud() {
    return {
      id: this.id.toString(),
      date: this.date,
      text: this.text,
    };
  }

  setProperty(propertyName, value) {
    if (Object.hasOwnProperty.call(this, propertyName)) {
      this[propertyName] = value;
    } else {
      console.error(`Property ${propertyName} does not exist.`);
    }
  }

  // Generic getter
  getProperty(propertyName) {
    if (Object.hasOwnProperty.call(this, propertyName)) {
      return this[propertyName];
    } else {
      console.error(`Property ${propertyName} does not exist.`);
      return undefined;
    }
  }
}
export default Note;
